import React from 'react'
import { Container } from 'react-bootstrap';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import "../About/About.css";
import cohete from "../../images/Content/cohete.png"
const Mision = () => {
  return (
    <div className='div-desarrollo col-md-6' data-aos="fade-up" data-aos-delay="4000">
    <h1 className='titulo-servicio'> <img className='icono-titulo' src={cohete} />Mision.<img className='icono-titulo' src={cohete} /></h1>
    <p className="parrafo-servicio" style={ { color:"White",}}>En NinnoTech, nos dedicamos a proporcionar soluciones tecnológicas personalizadas que transforman la presencia en línea de nuestros clientes. Nos esforzamos por crear páginas web simples pero atractivas, diseñadas para cautivar a los visitantes desde el primer momento. Creemos que la simplicidad y la elegancia son fundamentales para una experiencia web exitosa, y trabajamos incansablemente para ofrecer sitios web que no solo sean visualmente impresionantes, sino también intuitivos y fáciles de navegar.</p>
</div>
  )
}

export default Mision